import { useAskBluejApiContext } from '../../api/context';
import { useQuery } from '@tanstack/react-query';
import { AuthenticationError } from '../../api/error';
import { generateReturnUrl } from '../../../../app-utils';

/**
 * Handles the user query to fetch the current user's information.
 *
 * If the user is not authenticated, it redirects to the login page.
 */
export function useWhoamiQuery() {
  const { api } = useAskBluejApiContext();

  return useQuery({
    queryKey: ['user'],
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    queryFn: async () => {
      return api.whoami().catch((error) => {
        if (error instanceof AuthenticationError) {
          // Don't retry, redirect to auth if the user is not authenticated
          window.location.href = `/login?url=${generateReturnUrl()}`;
        }
        throw error;
      });
    }
  })
}
